// import { storage } from '../firebaseInit'

export default {
  state: {

  },
  mutations: {

  },
  actions: {

  },
  getters: {

  }

}



// WEBPACK FOOTER //
// ./src/store/helpers.js